export const getRequiredLabelProp = (props) => {
    if (shouldAddRequiredSign(props)) {
        return { label: getRequiredLabel(props.label) };
    }
    return { label: props.label };
}

const shouldAddRequiredSign = (props) => {
    const label = props?.label;
    const required = props?.required;
    return label != undefined && required != undefined && required === true;
}

const getRequiredLabel = (label) => {
    return `${label}*`;
}